<template>
  <div class="content_box" style="background-color: #f5f6fa">
    <hear></hear>
    <div class="content xcon">
      <el-tabs v-model="activeNames" :tab-position="tabPosition">
        <el-tab-pane name="tong1" label="消息通知">
          <el-tabs class="tac" tab-position="left">
            <el-row style="padding-top: 5px; margin-bottom: 5px" class="mb8">
              <el-col :span="18">
                <el-button
                  @click="shuaxin"
                  type="info"
                  icon="el-icon-refresh-right"
                ></el-button>
              </el-col>
              <el-col :span="6" style="" class="seach">
                <el-input
                clearable
                  v-model="params.keyWrod"
                  placeholder="请输入关键字"
                ></el-input>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="shuaxin"
                ></el-button>
              </el-col>
            </el-row>
            <el-table
              style="flex:1;"
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              class="table xtable"
              stripe
              border
              align="center"
              v-loading="loading"
              highlight-current-row
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column align="center" label="序号" width="50" prop="id">
              </el-table-column>
              <el-table-column
                align="center"
                prop="me_code"
                label="消息编号"
                width="220"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="title"
                label="消息标题"
                width="220"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="content"
                label="消息内容"
                width="220"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="type"
                label="消息类型"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <!-- 消息类型 system 系统消息 sms 短信消息 -->
                  <span v-show="scope.row.type == 1">系统消息</span>
                  <span v-show="scope.row.type == 2">短信消息</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="type"
                label="接收人类型"
                width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <!-- 消息类型 system 系统消息 sms 短信消息 -->
                  <span v-show="scope.row.js_type == 1">申请方</span>
                  <span v-show="scope.row.js_type == 2">出函方</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="js_name"
                label="接收人姓名"
                width="180"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="type"
                label="发送人类型"
                width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <!-- 消息类型 system 系统消息 sms 短信消息 -->
                  <span v-show="scope.row.fs_type == 1">申请方</span>
                  <span v-show="scope.row.fs_type == 2">出函方</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="fs_name"
                align="center"
                label="发送人"
                width="220"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="fs_time"
                label="发送时间"
                width="220"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-show="scope.row.fs_time == null"></span>
                  <span v-show="scope.row.fs_time != null">{{
                    scope.row.fs_time | dateFormat
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="ck_time"
                label="查看时间"
                width="220"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-show="scope.row.ck_time == null">未查看</span>
                  <span v-show="scope.row.ck_time != null">{{
                    scope.row.ck_time | dateFormat
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="status"
                label="状态"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <!-- 是否已查看 0:未查看 1:已查看 -->
                  <span v-show="scope.row.state == 1">未查看</span>
                  <span v-show="scope.row.state == 2">已查看</span>
                  <span v-show="scope.row.state == 3">已删除</span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                align="center"
                label="操作"
                width="120"
              >
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                  <el-button
                    @click="handleClicks(scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="block">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30]"
                :page-size="params.page_limit"
                :current-page="params.page"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane name="tong2" label="招标公告">
          <el-tabs type="card" v-model="activeName">
            <el-tab-pane label="未开具保函" class="xinde" name="first">
              <zhao></zhao
            ></el-tab-pane>
            <el-tab-pane label="已开具保函" class="xinde" style="
    height: 100%;
" name="second">
              <zhaos></zhaos
            ></el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <!-- 完结 -->
        <el-tab-pane name="tong3" label="中标公告">
          <el-tabs type="card" v-model="activeName">
            <el-tab-pane label="未开具保函" class="xinde" name="first">
              <zhong></zhong
            ></el-tab-pane>
            <el-tab-pane label="已开具保函" class="xinde" name="second">
              <zhongs></zhongs
            ></el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
    </div>
    <binad></binad>
  </div>
</template>

<script>
import hear from "@/components/hear.vue";
import binad from ".././../components/dinad.vue";
import zhao from "@/view/biao/zhao.vue";
import zhaos from "@/view/biao/zhaos.vue";
import zhong from "@/view/biao/zhong.vue";
import zhongs from "@/view/biao/zhongs.vue";
import {
  kuaidi,
  ziliao,
  bhlist,
  bh_detail,
  fapiao,
  list,
  homepage,
  messageDel,
  password,
  logou,
  shenqingkaipiao
} from "@/api/system/usercenter.js";
export default {
  components: {
    hear,
    // cioand,
    binad,
    zhong,
    zhao,
    zhaos,
    zhongs
  },
  data() {
    return {
      tabPosition: "left",
      activeName: "first",
      // 快递参数
      kuaidi_params: {
        limit: 10,
        offset: 0
      },
      activeNames: "tong1",
      // 快递总条数
      kuaidi_total: null,
      baohan_total: null,
      // 快递列表
      kuaidilist: [],
      jigouName: "",
      jigouNames: "",
      // 个人资料
      ziliaolist: {},
      labelPosition: "top",
      // 保函列表
      Bh_list: [],
      // 保函详情参数
      Bh_details: {
        offset: 0,
        limit: 10
      },
      // 保函详情内容
      Bh_content: {},
      // 保函总条数
      Bh_total: null,
      // 发票参数
      fapiao_params: {
        offset: 0,
        limit: 10,
        keywords: ""
        // user_id: sessionStorage.getItem("user_id"),
      },
      baohan_params: {
        offset: 0,
        limit: 10,
        keywords: ""
        // user_id: sessionStorage.getItem("user_id"),
      },
      weidaili_search: "",
      // 发票总条数
      fapiao_total: null,
      // 发票列表容器
      fapiaolist: [],
      // 修改密码参数
      form: {
        password: "",
        old_password: ""
      },
      password_again: "",
      xiang: false,
      formdata: {},
      params: {
        type: "",
        keyWrod: "",
        page: 1,
        page_limit: 10,
        type: ""
      },
      total: 0,
      tableData: [],
      loading:true,
    };
  },
  created() {
    if (this.$route.query.id) {
      this.activeNames = this.$route.query.id;
    }
  },
  mounted() {
    this.getBhlist();
    this.getBhdetail();
    this.getFapiao();
    this.getList();
  },
  methods: {
    // 获取快递列表
    shuaxin() {
      this.loading=true;
      
        var that=this
      setTimeout(function() {
          that.getList();
      }, 500);
    },
    // 通知列表
    getList() {
      list({ ...this.params }).then(res => {
        if (res.data.code == 1) {
          this.loading=false
          this.tableData = res.data.data.rows;
          this.total = res.data.data.total;
        }
      });
    },
    cionfan() {
      if (this.xiang) {
        this.xiang = false;
        // this.$router.go(0)
      } else {
      }
    },
    handleSizeChange_baohan(val) {
      this.Bh_details.limit = val;
      this.getBhlist();
    },

    handleCurrentChange_baohan(val) {
      this.Bh_details.offset = parseInt(val - 1) * this.Bh_details.limit;
      this.getBhlist();
    },
    handleAdd() {},

    handleClick(e) {
      homepage({ me_code: e.me_code }).then(res => {
        if ((res.data.code = 1)) {
          this.formdata = e;
          this.$router.push({ name: "xiaoxi", query: e });
          // this.formdata.ck_time=this.dateFormat(this.formdata.ck_time)
          // this.formdata.fs_time=this.dateFormat(this.formdata.fs_time)
          // this.xiang = true;
          // this.getList();
          //   this.$message({
          //   type: this.xiang,
          //   message: "成功!",
          // });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleClicks(e) {
      var taht = this;

      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          messageDel({ me_code: e.me_code }).then(res => {
            if (res.data.code == 1) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.getList();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 获取保函列表
    getBhlist() {
      bhlist(this.Bh_details).then(res => {
        if (res.data.code == 1) {
          this.Bh_list = res.data.data.rows;
          this.Bh_total = res.data.data.total;
        } else {
          this.$message.error("网络异常");
        }
      });
    },
    // 获取保函详情 点击详情按钮
    getBhdetail() {
      let bh_id = 1;
      bh_detail({ bh_id }).then(res => {
        if (res.data.code == 1) {
          this.Bh_content = res.data.data.jiben;
        } else {
          this.$message.error("网络异常");
        }
      });
    },
    handleSizeChange_bh(val) {
      this.Bh_details.limit = val;
      this.getBhlist();
    },
    handleCurrentChange_bh(val) {
      this.Bh_details.offset = parseInt(val - 1) * 10;
      this.getBhlist();
    },
    // 获取发票列表
    getFapiao() {
      fapiao(this.fapiao_params).then(res => {
        if (res.data.code == 1) {
          this.fapiaolist = res.data.data.rows;

          this.fapiao_total = res.data.data.total;
        } else {
          this.$message.error("网络异常");
        }
      });
    },
    // 申请发票
    handleshenqing(id) {
      shenqingkaipiao({ user_id: sessionStorage.getItem("user_id"), id }).then(
        res => {
          if (res.data.code == 1) {
            this.$message.success("申请成功");
            this.getFapiao();
          } else {
            this.$message.error(res.data.msg);
          }
        }
      );
    },
    handleSizeChange(val) {
      console.log("handleSizeChange",val);
      this.fapiao_params.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log("handleCurrentChange",val);
      this.fapiao_params.offset =val;
      this.getList();
    },
    handleSearch() {
      this.fapiao_params.keywords = this.weidaili_search;
      this.getList();
    }
  }
};
</script>

<style>
.el-table_1_column_1 .cell{
  display: flex;
    justify-content: center;
}
.xcon .el-tabs--top{
  /* height: 100%; */
  flex:1;
}
.xcon .el-tabs__header {
    margin: 0 0 10px;
}
.xcon .el-tabs__content {
  height: 100%;
  overflow: auto;
  padding-right: 6px;
}
/* .xcon .is-left{
  display: none;
} */
.xcon .el-tab-pane {
  height: 100%;
  /* display: flex;
    flex-direction: column; */
}
.xcon .el-tabs__content{
  display:flex;
  flex-direction: column;
}
</style>
<style scoped lang="scss">
.update_password {
  width: 100%;
  display: flex;
  justify-content: center;
  .update {
    width: 30%;
  }
}
::v-deep.el-form--inline .el-form-item {
  width: 100%;
}
::v-deep.el-form--inline .el-form-item__content {
  width: 100%;
}
.search {
  float: right;
  width: 20%;
  margin: 10px 0 10px 0;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  display: flex;
  ::v-deep.el-input__inner {
    border: none !important;
  }
  .el-button {
    border: none;
  }
}
::v-deep.el-input__inner {
  border: none !important;
}
.block {
  display: flex;
    justify-content: flex-end;
    padding: 10px;

  // margin-top: 5vh;
}
::v-deep.el-tabs--left {
  // min-height: calc(100vh - 72px);
  height: 100%;
  .el-tabs__item.is-left {
    width: 200px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    font-family: MicrosoftYaHei-, MicrosoftYaHei;
    font-weight: normal;
    color: #000000;
  }

  .el-tabs__item.is-active {
    background: #1795ff;
    color: #fff;
  }
}
.tac {
 
  display: flex;
 
}
.content_box {
  height: 100%;
  //  min-height: calc(100vh + 155px);
  //  min-height: calc(100% + 155px);
  display: flex;
  flex-direction: column;
  .content {
    // margin: 0 auto;
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    // padding: 0 2%;
    margin-top: 3px;
    background-color: #fff;
    // min-height: calc(100vh - 72px);

    .card_father {
      height: 76vh;
      /* padding-top: 10px; */
      margin-top: 10px;
      overflow: auto;
    }
    .card {
      width: 95%;
      height: 200px;
      background: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
      border-radius: 8px 8px 8px 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      opacity: 1;
      margin: 20px auto;
      .card_bh {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        .card_content_top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-left: 10px;
          .card_left {
            display: flex;
          }
          .card_right {
            display: flex;
            div {
              width: 145px;
              height: 47px;
              border-radius: 4px 4px 4px 4px;
              opacity: 1;
              border: 2px solid #1890ff;
              line-height: 47px;
              text-align: center;
              font-size: 18px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #1890ff;
              margin-right: 10px;
              cursor: pointer;
            }
          }
          .top_title {
            font-size: 24px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #333333;
          }
          .top_right {
            margin-left: 30px;
            width: 113px;
            height: 33px;
            background: #1795ff;
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            font-size: 18px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 33px;
          }
        }
        .card_details {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 40px 0 10px;
          font-size: 18px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          .every {
            display: flex;
            align-items: center;
            i {
              color: #1890ff;
            }
          }
        }
      }
      .card_content {
        margin-left: 10px;
        height: 180px;
        opacity: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        span {
          color: #ccc;
        }
      }
      .card_content_center {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        margin-right: 30px;
      }
    }
    .card_content_bottom {
      display: flex;
      .right_content {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
    }
    .card_right {
      margin-right: 30px;
    }
  }
  .personal_box {
    width: 100%;
    display: flex;
    justify-content: center;
    .box_personal_content {
      width: 70%;
    }
  }
  .Personal {
    width: 40%;
  }

  ::v-deep .Personal .el-input__inner {
    width: 100%;
    border: 0;
    border-bottom: #ccc 1px solid;
    border-radius: 0;
    padding: 0;
  }
  ::v-deep.el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #000000;
  }
}
.photo {
  border-radius: 50%;
  width: 100px;
}
.fromsBox {
  overflow: auto;
  padding: 10px;
}
.cion {
  height: 100%;
}
.fromsBoxs {
  height: 100%;
  overflow: auto;
  padding: 10px;
}

//
</style>



// WEBPACK FOOTER //
// src/view/index/sNavbar.vue